import * as config from './index';
export const REPORT_MODULE = {
  storeReport: config.storeReport,
  dispatchReport: config.dispatchReport,
  dispatchHistoryReport: config.dispatchHistoryReport,
  cancellationTicketReport: config.cancellationTicketReport,
  arrearReport: config.arrearReport,
  auditReport: config.auditReport,
  saleNoteStatusReport: config.saleNoteStatusReport,
  saleNoteStatusSkuReport: config.saleNoteStatusSkuReport,
  modificationReport: config.modificationReport,
  reportContainer: config.reportContainer,
  reportDiscount: config.reportDiscount,
  saleNoteReport: config.saleNoteReport,
  withdrawalCapacityReport: config.withdrawalCapacityReport,
  pickingCapacityReport: config.pickingCapacityReport,
  dispatchCapacityReport: config.dispatchCapacityReport,
  requiredSKU: config.requiredSKU,
  requiredSKUDetail: config.requiredSKUDetail,
  refundsReport: config.refundsReport,
  massiveProductCancellation: config.massiveProductCancellation,
  massiveProductRefund: config.massiveProductRefund,
  quotationObservations: config.quotationObservations
};
